export const GlobalKeys = {
    SequentialFiles: 'sequentialFiles',
    QcEntities: 'qcEntities',
    AbortControllers: 'abortControllers',
    CancelTokens: 'cancelTokens',
};

export const getAllKeys = () => {
    const output: Array<string> = [];
    for (const key in GlobalKeys) {
        if (Object.prototype.hasOwnProperty.call(GlobalKeys, key)) {
            output.push(key);
        }
    }
    return output;
};
